export const getAdvices = (state) => state.advices
export const getAdvice = (state) => (advice_id) => state.advices.find(x => x.id === advice_id) || {}
export const getAdvicesMeta = (state) => state.meta_data


